<div class="item-container pt-0">
    <div class="edit-icons" (click)="onCancel()" mat-dialog-close>
        <i class="material-icons">close</i>
    </div>
    <div class="content">
       
        <div class="delete-img mt-4  text-center">
            <img src="assets/images/icons/alert_ic.svg" class="img-fluid" *ngIf="(dialogData.api_type=='alert_complete_sub_section') ||
            (dialogData.api_type=='assign_playlist') || (dialogData.api_type=='exam_alert')" alt="">
            <img src="assets/images/icons/support_ic.svg" class="img-fluid" *ngIf="dialogData.api_type=='contact_admin'"  alt="">
            <img src="assets/images/icons/please_buy.svg" class="img-fluid" *ngIf="dialogData.api_type=='please_buy'"  alt="">
            <img src="assets/images/icons/something went_wrong_ic.svg" class="img-fluid"  *ngIf="dialogData.api_type=='error'" alt="">
            <img src="assets/images/object_icons/next_exam.png" class="img-fluid" *ngIf="dialogData.api_type=='completed_view_course'" alt="">
        </div>
        <h5 class="text-center item-txt mt-3" *ngIf="dialogData.api_type!='completed_view_course'&&dialogData.api_type!='please_buy'">{{"Alert" | translate}}</h5>
        <h5 class="text-center item-txt mt-3" *ngIf="dialogData.api_type=='please_buy'">{{"Enhance Your Experience" | translate}}</h5>
        <div class="item-small mt-3 text-center" *ngIf="dialogData.api_type=='alert_complete_sub_section'">
            {{"You must first complete all the sub sections of the section to be granted access to the exam." | translate}}</div>
        <div class="item-small mt-3 text-center" *ngIf="dialogData.api_type=='assign_playlist'">
            {{"Playlist assigning limit reached. Please contact admin at " | translate}} <a  href="mailto:info@univate.ie">info@univate.ie</a>
            {{"to increase limit"|translate}}</div>
        <div class="item-small mt-3 text-center" *ngIf="dialogData.api_type=='contact_admin'">
            {{"Please contact admin at " | translate}} <a href="mailto:info@univate.ie">info@univate.ie</a>
        </div>
        <div class="item-small mt-3 text-center" *ngIf="dialogData.api_type=='please_buy'">
            {{"Unlock the full potential of this feature by acquiring it through a purchase, ensuring a seamless and enhanced user experience" | translate}}
        </div>
        <div class="item-small mt-3 text-center" *ngIf="dialogData.api_type=='exam_alert'">
            {{"You must first attend the unattended exam given above and then only you can attend this exam." | translate}}
        </div>
        <div class="item-small mt-3 text-center" *ngIf="dialogData.api_type=='error'">
            {{"Something went wrong please try again." | translate}}
        </div>
        <div class="item-small mt-3 text-center" *ngIf="dialogData.api_type=='completed_view_course'">
            {{"You've successfully wrapped up the preview course." | translate}}
        </div>
        <!-- <div class="item-small mt-3 text-center">
            {{"You must first attend the unattended exam given above and then only you can attend this exam" | translate}}</div>
        <div class="item-small mt-3 text-center">
          {{"Are you sure you want to hide this course ? If you hide the course it will be no longer visible to the new buyer. " | translate}}</div>     -->
    </div>
    <div class="btn-container d-flex mt-4">
        <button mat-raised-button color="primary" class="auth-form-btn mt-3 no-sh-btn " type="submit" mat-dialog-close (click)="onCancel()">{{"Ok"|translate}}</button>
    </div>
</div>